/* import __COLOCATED_TEMPLATE__ from './loading-availability.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './loading-availability.module.scss';

@classic
@classNames(styles.component)
export default class RequestStepsLoadingLoadingAvailability extends Component {}
